(function () {
	'use strict';

	const breakpoints = {
	  'sm': 600,
	  'md': 1024,
	  'lg': 1200,
	  'xl': 1440,
	  'page-max': 1660
	};

	var Breakpoints = /*#__PURE__*/Object.freeze({
		__proto__: null,
		breakpoints: breakpoints
	});

	const loader = `<div class="loading">
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
  </div>
`;
	const wrappedLoader = `<span class="btn-state is-loading" style="height: 10px;">
  <span class="state-label">
    ${loader}
  </span>
</span>
`;
	const preorderInputTemplate = (inputProperty, inputValue, preOrderDate) => {
	  return `<input id='pre-order' type='hidden' name='properties[${inputProperty}]' value='${inputValue}'>
  <input id='pre-order-tag' type='hidden' name='properties[_is_preorder]' value='true'>
  <input id='pre-order-date' type='hidden' name='properties[_preorder_date]' value='${preOrderDate}'>
  `;
	};

	var ElementTemplates = /*#__PURE__*/Object.freeze({
		__proto__: null,
		loader: loader,
		preorderInputTemplate: preorderInputTemplate,
		wrappedLoader: wrappedLoader
	});

	var events = {
	  POLENE_LIBS_READY: 'POLENE_LIBS_READY',
	  PRODUCT_DATA_LOADED: 'PRODUCT_DATA_LOADED',
	  CART_UPDATED: 'CART_UPDATED',
	  CART_DOM_UPDATED: 'CART_DOM_UPDATED',
	  QUANTITY_SELECTOR_UPDATE: 'QUANTITY_SELECTOR_UPDATE',
	  CART_LINE_ITEM_UPDATE: 'CART_UPDATE',
	  CART_ERROR: 'CART_ERROR',
	  AJAX_UPDATED: 'AJAX_UPDATED',
	  CHANGE_CURSOR: 'CHANGE_CURSOR',
	  FAVORITES_UPDATED: 'FAVORITES_UPDATED',
	  WISHLIST_READY: 'WISHLIST_READY',
	  FILTERS_UPDATED: 'FILTERS_UPDATED',
	  PRODUCT_CARD_RENDERED: 'PRODUCT_CARD_RENDERED',
	  FILTER_CONTENT_UPDATED: 'FILTER_CONTENT_UPDATED',
	  CLOSE_OPTIONS: 'CLOSE_OPTIONS',
	  TOGGLE_BIS: 'TOGGLE_BIS',
	  UPDATE_BIS: 'UPDATE_BIS',
	  BIS_SUBSCRIBED: 'BIS_SUBSCRIBED',
	  ANNOUNCEMENT_BAR_RENDERED: 'ANNOUNCEMENT_BAR_RENDERED',
	  TRIGGER_NOTIFICATION_LAYOUT: 'TRIGGER_NOTIFICATION_LAYOUT',
	  TOGGLE_DELETE_ADDRESS: 'TOGGLE_DELETE_ADDRESS',
	  ACTIVE_SLIDE_CHANGE: 'ACTIVE_SLIDE_CHANGE',
	  CAROUSEL_USER_SWIPE: 'CAROUSEL_USER_SWIPE',
	  CART_FETCHED: 'CART_FETCHED',
	  NEWSLETTER_SUBSCRIBED: 'NEWSLETTER_SUBSCRIBED',
	  ACCORDION_OPENED: 'ACCORDION_OPENED',
	  WISHLIST_ADDED: 'WISHLIST_ADDED',
	  WISHLIST_REMOVED: 'WISHLIST_REMOVED',
	  CUSTOMER_REGISTERED: 'CUSTOMER_REGISTERED',
	  CUSTOMER_LOGIN: 'CUSTOMER_LOGIN',
	  COLLECTION_FILTERS_RENDERED: 'COLLECTION_FILTERS_RENDERED',
	  COLLECTION_LAYOUT_CHANGING: 'COLLECTION_LAYOUT_CHANGING',
	  COLLECTION_LAYOUT_CHANGED: 'COLLECTION_LAYOUT_CHANGED',
	  SEARCH_OVERLAY_TOGGLED: 'SEARCH_OVERLAY_TOGGLED',
	  PDP_CAROUSEL_GALLERY_SWIPE: 'PDP_CAROUSEL_GALLERY_SWIPE',
	  PDP_CAROUSEL_PACKSHOT_SWIPE: 'PDP_CAROUSEL_PACKSHOT_SWIPE',
	  PDP_GALLERY_OPENED: 'PDP_GALLERY_OPENED',
	  ARTICLE_CLICKED: 'ARTICLE_CLICKED',
	  EDITO_MENU_CLICKED: 'EDITO_MENU_CLICKED'
	};

	var Events = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: events
	});

	const cleanPath = path => path.replace(/\/+/g, '/');
	const cleanPaths = paths => {
	  return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
	};
	const ROOT_PATH = window?.Shopify?.routes?.root || '/';
	cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
	cleanPaths({
	  WISHLIST: `${ROOT_PATH}/pages/wishlist`,
	  ACCOUNT: `${ROOT_PATH}/account`,
	  LOGIN: `${ROOT_PATH}/account/login`,
	  LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
	});
	window.P1?.klaviyo?.public_key;
	window.P1?.klaviyo?.list_id;
	const FOCUSABLE_SELECTORS = ['button:not([disabled])', '[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"]):not([disabled])'].join(', ');
	const CLIENT_TOKEN_COOKIE_NAME = 'shopify_pixel_client_token';

	const clamp = (min, val, max) => Math.min(max, Math.max(min, val));
	const parseProductForm = formData => {
	  const regEx = /properties\[(.+?)\]/;
	  const array = [];
	  let obj = {};
	  for (const [key, value] of formData) {
	    const propertyKey = key.match(regEx)?.['1'];
	    if (key === 'id') {
	      obj = {
	        properties: {}
	      };
	      array.push(obj);
	    }
	    if (propertyKey) {
	      obj['properties'][propertyKey] = value;
	    } else {
	      obj[key] = value;
	    }
	  }
	  return array;
	};
	const dispatchEvent = (target, name, data) => {
	  const event = new CustomEvent(name, {
	    detail: data
	  });
	  target.dispatchEvent(event);
	};
	const generateImageUrl = url => {
	  let imageUrl = '';
	  if (url) {
	    imageUrl = url.replace('123x321', '768x');
	  }
	  return imageUrl;
	};
	const setScrollbarWidth = () => {
	  const outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.overflow = 'scroll';
	  outer.style.msOverflowStyle = 'scrollbar';
	  document.body.appendChild(outer);
	  const inner = document.createElement('div');
	  outer.appendChild(inner);
	  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
	  if (outer.parentNode) {
	    outer.parentNode.removeChild(outer);
	  }
	  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
	};
	function getDocumentScrollTop() {
	  if (window.pageYOffset === undefined) {
	    return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	  }
	  return window.pageYOffset;
	}
	function scrollToPosition(destination, duration, callback) {
	  const start = getDocumentScrollTop();
	  let startTime = 0;
	  const delta = destination - start;
	  function easing(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t + b;
	    }
	    t -= 2;
	    return c / 2 * (t * t * t + 2) + b;
	  }
	  function loop(time) {
	    if (!startTime) {
	      startTime = time;
	    }
	    const runTime = time - startTime;
	    if (duration > runTime) {
	      requestAnimationFrame(loop);
	      window.scrollTo(0, easing(runTime, start, delta, duration));
	    } else {
	      if (destination !== delta + start) {
	        window.scrollTo(0, delta + start);
	      }
	      if (typeof callback === 'function') {
	        callback(+new Date());
	      }
	    }
	  }
	  requestAnimationFrame(loop);
	}
	function scrollToElement(element, duration, offset = 0, callback) {
	  const rect = element.getBoundingClientRect();
	  const offsetTop = rect.top + getDocumentScrollTop() - offset;
	  scrollToPosition(offsetTop, duration || 500, callback);
	}
	function replaceInnerHtml(element, content) {
	  element.innerHTML = content;
	}
	const debounce = (func, wait) => {
	  let timeout = null;
	  return function (...args) {
	    if (timeout) clearTimeout(timeout);
	    timeout = setTimeout(() => func.apply(this, args), wait);
	  };
	};
	const prefersReducedMotion = () => {
	  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	};
	const scrollBehavior = () => prefersReducedMotion() ? 'auto' : 'smooth';
	const onAnimationEnd = (element, callback) => {
	  const handleAnimationEnd = () => {
	    callback();
	    element.removeEventListener('animationend', handleAnimationEnd);
	  };
	  element.addEventListener('animationend', handleAnimationEnd);
	};
	const fetchConfig = (type = 'json', options = {}) => {
	  return {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json',
	      'Accept': `application/${type}`,
	      'X-Requested-With': 'XMLHttpRequest'
	    },
	    ...options
	  };
	};
	const isMobile = () => window.innerWidth < breakpoints.md;
	const isRTL = () => document.documentElement.dir === 'rtl';
	const replaceMultiplePairs = (str, replacements) => {
	  const escapedChars = replacements.map(([char]) => char.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	  const regex = new RegExp(escapedChars.join('|'), 'g');
	  return str.replace(regex, match => {
	    const replacement = replacements.find(([char]) => char === match);
	    return replacement ? replacement[1] : match;
	  });
	};
	const mod = (a, b) => {
	  return (a % b + b) % b;
	};
	const isFocusable = el => {
	  if (!el.matches(FOCUSABLE_SELECTORS)) return false;
	  return !el.hasAttribute('disabled') && el.offsetParent !== null && el.tabIndex !== -1;
	};
	const buildPowerXyzUrl = (companyEid, SKU) => {
	  if (!companyEid || !SKU) return '';
	  return `https://api.power.xyz/company/${companyEid}/asset/sku~${SKU}`;
	};
	const addScrollEndListener = (element, callback, options = {}) => {
	  const {
	    delay = 100,
	    once = false,
	    passive = true,
	    signal
	  } = options;
	  const target = element;
	  if ('onscrollend' in element) {
	    target.addEventListener('scrollend', callback, {
	      once,
	      passive,
	      signal
	    });
	  } else {
	    let timeoutId;
	    let hasExecuted = false;
	    const scrollHandler = () => {
	      clearTimeout(timeoutId);
	      timeoutId = setTimeout(() => {
	        if (once && hasExecuted) return;
	        callback();
	        hasExecuted = true;
	        if (once) target.removeEventListener('scroll', scrollHandler);
	      }, delay);
	    };
	    target.addEventListener('scroll', scrollHandler, {
	      passive,
	      signal
	    });
	  }
	};
	const relocateElementIfNeeded = element => {
	  const relocateTo = element.dataset.relocateTo;
	  if (!relocateTo) return;
	  const targetElement = document.querySelector(`[data-ref="${relocateTo}"]`);
	  if (targetElement && element.parentElement !== targetElement) {
	    targetElement.appendChild(element);
	  }
	};
	const getBaseDomain = () => {
	  const parts = window.location.hostname.split('.');
	  if (parts.length > 2 && !window.location.hostname.includes('localhost')) {
	    return `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
	  }
	  return window.location.hostname;
	};
	const setCookie = (name, value, days, domain) => {
	  const expires = new Date();
	  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
	  const cookieDomain = domain || getBaseDomain();
	  const isSecure = window.location.protocol === 'https:';
	  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;domain=${cookieDomain};SameSite=Lax${isSecure ? ';Secure' : ''}`;
	};
	const getCookie = name => {
	  const nameEQ = `${name}=`;
	  const ca = document.cookie.split(';');
	  for (let i = 0; i < ca.length; i++) {
	    let c = ca[i];
	    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
	    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	  }
	  return null;
	};
	const eraseCookie = (name, domain) => {
	  const cookieDomain = domain || getBaseDomain();
	  document.cookie = `${name}=; Path=/; Domain=${cookieDomain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	};
	const generateClientToken = () => {
	  const timestamp = Date.now().toString(16);
	  const randomPart = crypto.randomUUID().replace(/-/g, '').substring(0, 16);
	  return `${timestamp}${randomPart}`;
	};
	const updateGlobalModals = () => {
	  const modals = document.querySelectorAll('component-modal[data-type=bis], component-modal[data-type=coming-soon]');
	  modals.forEach(modal => {
	    if (modal instanceof HTMLElement && 'updatedCallback' in modal && typeof modal.updatedCallback === 'function') {
	      queueMicrotask(() => modal.updatedCallback());
	    }
	  });
	};
	const throttle = (callback, delay) => {
	  let isWaiting = false;
	  return (...args) => {
	    if (isWaiting) {
	      return;
	    }
	    callback(...args);
	    isWaiting = true;
	    setTimeout(() => {
	      isWaiting = false;
	    }, delay);
	  };
	};
	function getVisibleFocusableElements(container) {
	  const focusableNodes = container.querySelectorAll(FOCUSABLE_SELECTORS);
	  return Array.from(focusableNodes).filter(element => {
	    if (typeof element.checkVisibility === 'function') {
	      return element.checkVisibility();
	    }
	    const hasDimensions = element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
	    if (!hasDimensions) return false;
	    const computedStyle = window.getComputedStyle(element);
	    return computedStyle.visibility !== 'hidden' && computedStyle.opacity !== '0';
	  });
	}
	const inertOutside = (keep, root) => {
	  if (keep === root || !root.contains(keep)) return [];
	  const changed = [];
	  let node = keep;
	  while (node && node !== root && node.parentElement) {
	    for (const sibling of Array.from(node.parentElement.children)) {
	      if (sibling === node || !(sibling instanceof HTMLElement) || sibling.inert) continue;
	      sibling.inert = true;
	      changed.push(sibling);
	    }
	    node = node.parentElement;
	  }
	  return changed;
	};
	const releaseInert = elements => {
	  elements.forEach(element => {
	    element.inert = false;
	  });
	};
	const getClientToken = () => {
	  const raw = getCookie(CLIENT_TOKEN_COOKIE_NAME);
	  if (!raw) return null;
	  try {
	    return decodeURIComponent(raw);
	  } catch {
	    return raw;
	  }
	};

	var Utils = /*#__PURE__*/Object.freeze({
		__proto__: null,
		addScrollEndListener: addScrollEndListener,
		buildPowerXyzUrl: buildPowerXyzUrl,
		clamp: clamp,
		debounce: debounce,
		dispatchEvent: dispatchEvent,
		eraseCookie: eraseCookie,
		fetchConfig: fetchConfig,
		generateClientToken: generateClientToken,
		generateImageUrl: generateImageUrl,
		getBaseDomain: getBaseDomain,
		getClientToken: getClientToken,
		getCookie: getCookie,
		getDocumentScrollTop: getDocumentScrollTop,
		getVisibleFocusableElements: getVisibleFocusableElements,
		inertOutside: inertOutside,
		isFocusable: isFocusable,
		isMobile: isMobile,
		isRTL: isRTL,
		mod: mod,
		onAnimationEnd: onAnimationEnd,
		parseProductForm: parseProductForm,
		prefersReducedMotion: prefersReducedMotion,
		releaseInert: releaseInert,
		relocateElementIfNeeded: relocateElementIfNeeded,
		replaceInnerHtml: replaceInnerHtml,
		replaceMultiplePairs: replaceMultiplePairs,
		scrollBehavior: scrollBehavior,
		scrollToElement: scrollToElement,
		scrollToPosition: scrollToPosition,
		setCookie: setCookie,
		setScrollbarWidth: setScrollbarWidth,
		throttle: throttle,
		updateGlobalModals: updateGlobalModals
	});

	const ANIMATION_DURATION = 800;
	const CASCADE_DELAY = 5;
	const RESET_SAFETY_MARGIN = 200;
	const ANIMATION_PROPERTIES_TO_RESET = ['transition', 'transition-delay', 'width', 'height', 'top', 'left', 'position', 'will-change'];
	const getAbsoluteBounds = (element, scrollY) => {
	  const rect = element.getBoundingClientRect();
	  return {
	    top: rect.top + scrollY,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left,
	    width: rect.width,
	    height: rect.height,
	    x: rect.x,
	    y: rect.y + scrollY
	  };
	};
	const calculateTotalFlipDuration = elementCount => ANIMATION_DURATION + 2 * elementCount * CASCADE_DELAY + RESET_SAFETY_MARGIN;
	const wait = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));
	const forceNextFrame = () => new Promise(resolve => {
	  requestAnimationFrame(() => {
	    requestAnimationFrame(() => resolve());
	  });
	});
	const getTransitionStyle = (duration = ANIMATION_DURATION, delay = 0) => `all ${duration}ms ${delay}ms cubic-bezier(.35, 0, .35, 1)`;
	const resetFlipStyles = state => {
	  state.parent.el.style.removeProperty('height');
	  state.parent.el.style.removeProperty('transition');
	  state.elements.forEach(item => {
	    ANIMATION_PROPERTIES_TO_RESET.forEach(prop => item.el.style.removeProperty(prop));
	  });
	};
	const latestTokens = new Map();
	const inFlightCounts = new Map();
	const flip = async (name, changeLayoutCallback) => {
	  const currentInFlight = (inFlightCounts.get(name) ?? 0) + 1;
	  inFlightCounts.set(name, currentInFlight);
	  if (currentInFlight === 1) {
	    dispatchEvent(window, 'COLLECTION_LAYOUT_CHANGING');
	  }
	  try {
	    if (prefersReducedMotion()) {
	      changeLayoutCallback();
	      return;
	    }
	    const token = Symbol(name);
	    latestTokens.set(name, token);
	    const parent = document.querySelector(`[data-flip-parent="${name}"]`);
	    if (!parent) {
	      changeLayoutCallback();
	      return;
	    }
	    const elements = Array.from(document.body.querySelectorAll(`[data-flip="${name}"]`));
	    if (elements.length === 0) {
	      changeLayoutCallback();
	      return;
	    }
	    const totalDuration = calculateTotalFlipDuration(elements.length);
	    document.body.style.setProperty('--flip-duration', `${totalDuration}ms`);
	    const initialScroll = window.scrollY;
	    const state = {
	      parent: {
	        el: parent,
	        height: parent.getBoundingClientRect().height
	      },
	      elements: elements.map(el => ({
	        el,
	        ...getAbsoluteBounds(el, initialScroll)
	      }))
	    };
	    resetFlipStyles(state);
	    changeLayoutCallback();
	    const postScroll = window.scrollY;
	    state.parent.new = parent.getBoundingClientRect().height;
	    state.elements.forEach(s => {
	      s.new = getAbsoluteBounds(s.el, postScroll);
	    });
	    state.parent.el.style.height = `${state.parent.height}px`;
	    state.elements.forEach(s => {
	      s.el.style.position = 'absolute';
	      s.el.style.willChange = 'width, height, top, left';
	      s.el.style.width = `${s.width}px`;
	      s.el.style.height = `${s.height}px`;
	      s.el.style.top = `${s.top}px`;
	      s.el.style.left = `${s.left}px`;
	    });
	    await forceNextFrame();
	    state.parent.el.style.transition = getTransitionStyle(ANIMATION_DURATION);
	    state.parent.el.style.height = `${state.parent.new}px`;
	    state.elements.forEach((s, index) => {
	      if (!s.new) return;
	      const cascadeOffset = (elements.length - index) * CASCADE_DELAY;
	      s.el.style.transition = getTransitionStyle(ANIMATION_DURATION + cascadeOffset, cascadeOffset);
	      s.el.style.width = `${s.new.width}px`;
	      s.el.style.height = `${s.new.height}px`;
	      s.el.style.top = `${s.new.top}px`;
	      s.el.style.left = `${s.new.left}px`;
	    });
	    await wait(totalDuration);
	    if (latestTokens.get(name) !== token) return;
	    resetFlipStyles(state);
	  } finally {
	    const remaining = (inFlightCounts.get(name) ?? 1) - 1;
	    inFlightCounts.set(name, remaining);
	    if (remaining === 0) dispatchEvent(window, 'COLLECTION_LAYOUT_CHANGED');
	  }
	};

	var FlipAnimation = /*#__PURE__*/Object.freeze({
		__proto__: null,
		flip: flip
	});

	const hydrateComponents = (components, ...additionalFunctions) => {
	  return {
	    components,
	    teardownFunctions: [],
	    async hydrate() {
	      additionalFunctions?.forEach(func => func());
	      const initializedComponents = await Promise.all(components.filter(Boolean).map(async component => {
	        const c = await component;
	        if (c.default) return c.default();else return () => {};
	      }));
	      this.teardownFunctions = initializedComponents.filter(c => typeof c === 'function');
	      window.teardown = () => this.teardownFunctions.forEach(teardown => teardown());
	    }
	  };
	};

	var Hydration = /*#__PURE__*/Object.freeze({
		__proto__: null,
		hydrateComponents: hydrateComponents
	});

	const mutation = (el, cb, config = {
	  childList: true,
	  subtree: true
	}) => {
	  const callback = mutationList => {
	    for (const mutation of mutationList) {
	      if (mutation.type === 'childList') {
	        cb(mutation);
	      }
	    }
	  };
	  const observer = new MutationObserver(callback);
	  observer.observe(el, config);
	  return observer;
	};
	const intersection = (el, callback, config = {
	  threshold: [0]
	}) => {
	  const observer = new IntersectionObserver(callback, config);
	  if (el) {
	    observer.observe(el);
	  }
	  return observer;
	};

	var Observer = /*#__PURE__*/Object.freeze({
		__proto__: null,
		intersection: intersection,
		mutation: mutation
	});

	const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
	const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
	function groupByRef(element, result, onlyFirst = false) {
	  const ref = element.getAttribute('data-ref');
	  if (!ref) return;
	  const refs = ref.split(' ').map(camelCase);
	  refs.forEach(capitalizedRef => {
	    if (onlyFirst) {
	      if (!result[capitalizedRef]) {
	        result[capitalizedRef] = element;
	      }
	    } else {
	      if (result[capitalizedRef]) {
	        if (Array.isArray(result[capitalizedRef])) {
	          result[capitalizedRef].push(element);
	        } else {
	          result[capitalizedRef] = [result[capitalizedRef], element];
	        }
	      } else {
	        result[capitalizedRef] = element;
	      }
	    }
	  });
	}
	const getElementByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref="${ref}"]`).join(',') : `[data-ref="${refs}"]`;
	  const elements = root.querySelectorAll(selector);
	  if (!elements) return {};
	  elements.forEach(element => groupByRef(element, result, true));
	  return result;
	};
	const getElementsByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
	  const elements = root.querySelectorAll(selector);
	  elements.forEach(element => groupByRef(element, result));
	  return result;
	};
	const getRefs = (target = document.body, watch) => {
	  const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
	  if (!root) {
	    return;
	  }
	  const name = root?.getAttribute('data-namespace');
	  return watch ? _watched(root, name, watch) : _refs(root, name, true);
	};
	function _refs(root, name, includeRoot) {
	  const attribute = name ? `data-ref-${name}` : 'data-ref';
	  return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
	    const dataset = name ? `ref${capitalize(name)}` : 'ref';
	    return {
	      ...(includeRoot && {
	        root
	      }),
	      ...refs,
	      ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
	        ...acc,
	        [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
	      }), {})
	    };
	  }, {});
	}
	function _watched(r, n, onChange) {
	  const observer = new MutationObserver(() => {
	    ref.current = _refs(r, n);
	    if (typeof onChange === 'function') onChange();
	  });
	  observer.observe(r, {
	    childList: true,
	    subtree: true
	  });
	  const ref = {
	    root: r,
	    current: _refs(r, n),
	    unwatch: observer.disconnect.bind(observer)
	  };
	  return ref;
	}
	const ref = getRefs();

	var Refs = /*#__PURE__*/Object.freeze({
		__proto__: null,
		camelCase: camelCase,
		capitalize: capitalize,
		getElementByRef: getElementByRef,
		getElementsByRef: getElementsByRef,
		getRefs: getRefs,
		ref: ref
	});

	let lockCount = 0;
	let previousOverflowY = '';
	var scrollLock = lock => {
	  if (lock) {
	    if (lockCount++ === 0) {
	      previousOverflowY = document.body.style.overflowY;
	      document.body.style.overflowY = 'hidden';
	    }
	  } else if (lockCount > 0 && --lockCount === 0) {
	    document.body.style.overflowY = previousOverflowY;
	  }
	};

	var ScrollLock = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: scrollLock
	});

	const plus = `<svg class="plus" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.87 17.87">
    <path fill="currentColor" d="m8.94,0C4.01,0,0,4.01,0,8.94s4.01,8.94,8.94,8.94,8.94-4.01,8.94-8.94S13.86,0,8.94,0Zm0,16.87c-4.38,0-7.94-3.56-7.94-7.94S4.56,1,8.94,1s7.94,3.56,7.94,7.94-3.56,7.94-7.94,7.94Z" />
    <polygon fill="currentColor" points="9.44 4.34 8.44 4.34 8.44 8.44 4.34 8.44 4.34 9.44 8.44 9.44 8.44 13.53 9.44 13.53 9.44 9.44 13.53 9.44 13.53 8.44 9.44 8.44 9.44 4.34" />
  </svg>`;
	const envelope = `<svg width="100%" height="100%" class="envelope" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1964 0.75H14.25V8.25H0.75V0.75H0.803571L7.5 7L14.1964 0.75ZM13.0972 0.75H1.90277L7.5 5.97409L13.0972 0.75ZM0 0H15V9H0V0Z" fill="currentColor"/>
</svg>`;
	const arrowDown = `<svg class="arrow-icon" width="100%" height="100%" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_602_15144)">
    <path d="M2.72266 0.000174669L2.72266 6.50391" stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" />
    <path d="M5.26647 3.99644L3.99477 5.25017L2.72308 6.50391L1.45138 5.25017L0.179687 3.99644" stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" />
  </g>
  <defs>
    <clipPath id="clip0_602_15144">
      <rect width="7" height="5.44444" fill="white" transform="translate(0 7) rotate(-90)" />
    </clipPath>
  </defs>
</svg>`;
	const close = `<svg width="100%" height="100%" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="23.5" cy="23.5" r="23.25" stroke="black" stroke-opacity="0.3" stroke-width="0.5" />
  <path d="M26.9128 26.9128L21 21" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
  <path d="M26.9128 21.0872L21 27" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
</svg>`;
	const cart = `<svg width="100%" height="100%" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M6.96786 0.625C6.15631 0.625 5.35897 0.924845 4.7656 1.54933C4.17834 2.16737 3.81877 3.07333 3.81021 4.24365H2.48465C2.13568 4.24365 1.84488 4.50175 1.77841 4.85449L0.424082 12.9158C0.324377 13.518 0.773049 14.0687 1.35466 14.0687H12.4635C13.0534 14.0687 13.502 13.518 13.394 12.9158L12.0314 4.85449C11.9737 4.50455 11.6789 4.24776 11.3335 4.2437L11.3252 4.24365H10.1255C10.1169 3.07333 9.75737 2.16737 9.17012 1.54933C8.57674 0.924845 7.77941 0.625 6.96786 0.625ZM9.37548 4.24365C9.36702 3.22935 9.05803 2.52019 8.62642 2.06594C8.18773 1.60426 7.59367 1.375 6.96786 1.375C6.34204 1.375 5.74798 1.60426 5.3093 2.06594C4.87768 2.52019 4.56869 3.22935 4.56024 4.24365H9.37548ZM1.35466 13.3187C1.26359 13.3187 1.13096 13.2143 1.15955 13.0396L2.51129 4.99365H11.2985L12.6589 13.0415L12.6602 13.0489C12.6892 13.2107 12.5689 13.3187 12.4635 13.3187H1.35466Z"/>
<path class="filled" d="M13.0243 12.9783L13.0243 12.9783L13.0249 12.982C13.0939 13.3667 12.8074 13.6937 12.4635 13.6937H1.35466C1.02213 13.6937 0.729448 13.3686 0.793985 12.9774C0.794005 12.9773 0.794025 12.9772 0.794046 12.9771L2.14752 4.92083C2.18461 4.73126 2.33256 4.61865 2.48465 4.61865H11.3252C11.4847 4.61865 11.6321 4.73799 11.6614 4.9155L11.6616 4.91699L13.0243 12.9783Z" fill="black" stroke="black" stroke-width="0.75" stroke-miterlimit="10"/>
</svg>
`;

	var SvgTemplates = /*#__PURE__*/Object.freeze({
		__proto__: null,
		arrowDown: arrowDown,
		cart: cart,
		close: close,
		envelope: envelope,
		plus: plus
	});

	var Language;
	(function (Language) {
	  Language["en"] = "en";
	  Language["fr"] = "fr";
	  Language["de"] = "de";
	  Language["nl"] = "nl";
	  Language["ko"] = "ko";
	  Language["ja"] = "ja";
	  Language["ar"] = "ar";
	})(Language || (Language = {}));
	const dateRegex = /[^0-9년월일年月日\-./ ]/g;
	const languageFormats = {
	  en: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  },
	  fr: {
	    year: 'A',
	    month: 'M',
	    day: 'J'
	  },
	  de: {
	    year: 'J',
	    month: 'M',
	    day: 'T'
	  },
	  nl: {
	    year: 'J',
	    month: 'M',
	    day: 'D'
	  },
	  ko: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  },
	  ja: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  },
	  ar: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  }
	};
	const displayFormats = {
	  en: 'MM/DD/YYYY',
	  fr: 'DD/MM/YYYY',
	  de: 'DD.MM.YYYY',
	  nl: 'DD-MM-YYYY',
	  ko: 'YYYY년 MM월 DD일',
	  ja: 'YYYY年MM月DD日',
	  ar: 'DD/MM/YYYY'
	};
	const browserLocale = window.Shopify?.locale.split('-')[0].trim() ?? navigator.language.split('-')[0].trim() ?? 'en';
	const storeLanguage = window.Shopify?.locale && window.Shopify?.country ? window.Shopify?.locale && window.Shopify?.locale.includes('-') ? window.Shopify?.locale : window.Shopify?.locale + '-' + window.Shopify?.country : navigator.language;
	const browserFormat = (() => {
	  try {
	    const parts = new Intl.DateTimeFormat(storeLanguage || 'en-US').formatToParts(new Date(2000, 0, 15));
	    return parts.map(part => {
	      if (part.type === 'day') return 'DD';
	      if (part.type === 'month') return 'MM';
	      if (part.type === 'year') return 'YYYY';
	      return part.value;
	    }).join('');
	  } catch (error) {}
	})();
	const noSepFormats = {
	  en: ['MMDDYYYY', 'DDMMYYYY'],
	  fr: ['DDMMYYYY', 'MMDDYYYY'],
	  de: ['DDMMYYYY', 'MMDDYYYY'],
	  nl: ['DDMMYYYY', 'MMDDYYYY'],
	  ko: ['YYYYMMDD', 'YYYYDDMM'],
	  ja: ['YYYYMMDD', 'YYYYDDMM'],
	  ar: ['DDMMYYYY', 'MMDDYYYY']
	};
	const parseFormats = ['YYYY-MM-DD', 'YYYY-DD-MM', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY/MM/DD', 'YYYY/DD/MM', 'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY.MM.DD', 'YYYY.DD.MM', 'DD.MM.YYYY', 'MM.DD.YYYY', 'YYYY년MM월DD일', 'YYYY년 MM월 DD일', 'YYYY年MM月DD日', 'YYYY年 MM月 DD日', 'YYYY MM DD', 'YYYY DD MM', 'DD MM YYYY', 'MM DD YYYY', ...(noSepFormats[browserLocale] ?? [])];

	var ConstantsDate = /*#__PURE__*/Object.freeze({
		__proto__: null,
		get Language () { return Language; },
		browserFormat: browserFormat,
		browserLocale: browserLocale,
		dateRegex: dateRegex,
		displayFormats: displayFormats,
		languageFormats: languageFormats,
		noSepFormats: noSepFormats,
		parseFormats: parseFormats,
		storeLanguage: storeLanguage
	});

	class QuantitySelectorUpdateEvent extends CustomEvent {
	  constructor(quantity, cartLine) {
	    super('QUANTITY_SELECTOR_UPDATE', {
	      detail: {
	        quantity,
	        cartLine
	      },
	      bubbles: true,
	      composed: true
	    });
	  }
	}
	class CartUpdateEvent extends CustomEvent {
	  constructor(data) {
	    super('CART_UPDATE', {
	      detail: data,
	      bubbles: true,
	      composed: true
	    });
	  }
	}
	class CartErrorEvent extends CustomEvent {
	  constructor(detail) {
	    super('CART_ERROR', {
	      detail,
	      bubbles: true,
	      composed: true
	    });
	  }
	}
	const MESSAGE_MAX_LENGTH = 200;
	const dispatchCartError = detail => {
	  try {
	    window.dispatchEvent(new CartErrorEvent({
	      ...detail,
	      message: String(detail.message ?? '').slice(0, MESSAGE_MAX_LENGTH)
	    }));
	  } catch {}
	};
	const cartErrorMessage = jsonOrError => {
	  if (jsonOrError instanceof Error) return jsonOrError.name;
	  const body = jsonOrError;
	  if (body && typeof body.description === 'string' && body.description) return body.description;
	  if (body && typeof body.message === 'string' && body.message) return body.message;
	  return 'unknown';
	};

	var CartEvents = /*#__PURE__*/Object.freeze({
		__proto__: null,
		CartErrorEvent: CartErrorEvent,
		CartUpdateEvent: CartUpdateEvent,
		QuantitySelectorUpdateEvent: QuantitySelectorUpdateEvent,
		cartErrorMessage: cartErrorMessage,
		dispatchCartError: dispatchCartError
	});

	class ModalEvent extends CustomEvent {
	  constructor(type, action, submitter) {
	    super('modal', {
	      detail: {
	        type,
	        action,
	        submitter
	      },
	      bubbles: true,
	      composed: true
	    });
	  }
	}

	var ModalEvents = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ModalEvent: ModalEvent
	});

	class ArticleCardVisibleEvent extends CustomEvent {
	  constructor(ref, url) {
	    super('article-card-visible', {
	      detail: {
	        ref,
	        url
	      },
	      bubbles: true,
	      composed: true
	    });
	  }
	}

	var BlogArticleEvents = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ArticleCardVisibleEvent: ArticleCardVisibleEvent
	});

	const MORPH_OPTIONS = {
	  childrenOnly: true,
	  reject(oldNode, newNode) {
	    if (newNode.nodeType === Node.TEXT_NODE && newNode.nodeValue?.trim() === '') {
	      return true;
	    }
	    if (newNode instanceof HTMLTemplateElement && newNode.shadowRootMode === 'open' && oldNode.parentElement && newNode.parentElement && oldNode.parentElement.tagName === newNode.parentElement.tagName && oldNode.parentElement?.shadowRoot != null) {
	      return true;
	    }
	    if (newNode.nodeType === Node.COMMENT_NODE && newNode.nodeValue === 'shopify:rendered_by_section_api') {
	      return true;
	    }
	    return false;
	  },
	  onBeforeUpdate(oldNode, newNode) {
	    if (oldNode instanceof Element && newNode instanceof Element) {
	      const attributes = ['product-grid-view'];
	      for (const attribute of attributes) {
	        const oldValue = oldNode.getAttribute(attribute);
	        const newValue = newNode.getAttribute(attribute);
	        if (oldValue && oldValue !== newValue) {
	          newNode.setAttribute(attribute, oldValue);
	        }
	      }
	      const elements = ['floating-panel-component'];
	      const ids = ['account-popover'];
	      for (const element of elements) {
	        const tagName = element.toUpperCase();
	        if (oldNode.tagName === tagName && newNode.tagName === tagName) {
	          const oldStyle = oldNode.getAttribute('style');
	          if (oldStyle) newNode.setAttribute('style', oldStyle);
	        }
	      }
	      for (const id of ids) {
	        if (oldNode.id === id && newNode.id === id) {
	          const oldStyle = oldNode.getAttribute('style');
	          if (oldStyle) newNode.setAttribute('style', oldStyle);
	        }
	      }
	      if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement && oldNode.style.viewTransitionName) {
	        newNode.style.viewTransitionName = oldNode.style.viewTransitionName;
	      }
	    }
	  },
	  onAfterUpdate(node) {
	    if (node instanceof HTMLElement && 'updatedCallback' in node && typeof node.updatedCallback === 'function') {
	      queueMicrotask(() => node.updatedCallback());
	    }
	    updateGlobalModals();
	  }
	};
	function morph(oldTree, newTree, options = MORPH_OPTIONS) {
	  if (!oldTree || !newTree) {
	    throw new Error('Both oldTree and newTree must be provided');
	  }
	  let newTreeNode;
	  if (typeof newTree === 'string') {
	    const parsedNewTree = new DOMParser().parseFromString(newTree, 'text/html').body.firstChild;
	    if (!parsedNewTree) {
	      throw new Error('newTree string is not valid HTML');
	    }
	    newTreeNode = parsedNewTree;
	  } else {
	    newTreeNode = newTree;
	  }
	  if (options.childrenOnly) {
	    updateChildren(newTreeNode, oldTree, options);
	    return oldTree;
	  }
	  if (newTreeNode.nodeType === 11) {
	    throw new Error('newTree should have one root node (not a DocumentFragment)');
	  }
	  return walk(newTreeNode, oldTree, options);
	}
	function walk(newNode, oldNode, options) {
	  if (!oldNode) return newNode;
	  if (!newNode) return oldNode;
	  if (newNode.isSameNode?.(oldNode)) return oldNode;
	  if (newNode.nodeType !== oldNode.nodeType) return newNode;
	  if (newNode instanceof Element && oldNode instanceof Element) {
	    if (oldNode.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') return oldNode;
	    if (newNode.tagName !== oldNode.tagName) return newNode;
	    const newKey = getNodeKey(newNode, options);
	    const oldKey = getNodeKey(oldNode, options);
	    if (newKey && oldKey && newKey !== oldKey) return newNode;
	  }
	  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-node-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-node-update')) {
	    updateChildren(newNode, oldNode, options);
	  } else {
	    updateNode(newNode, oldNode, options);
	    updateChildren(newNode, oldNode, options);
	  }
	  options.onAfterUpdate?.(oldNode);
	  return oldNode;
	}
	function updateNode(newNode, oldNode, options) {
	  options.onBeforeUpdate?.(oldNode, newNode);
	  if (newNode instanceof HTMLDetailsElement && oldNode instanceof HTMLDetailsElement || newNode instanceof HTMLDialogElement && oldNode instanceof HTMLDialogElement) {
	    if (!newNode.hasAttribute('declarative-open')) {
	      newNode.open = oldNode.open;
	    }
	  }
	  if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement) {
	    for (const attr of ['slot', 'sizes']) {
	      const oldValue = oldNode.getAttribute(attr);
	      const newValue = newNode.getAttribute(attr);
	      if (oldValue !== newValue) {
	        if (oldValue == null) {
	          newNode.removeAttribute(attr);
	        } else {
	          newNode.setAttribute(attr, oldValue);
	        }
	      }
	    }
	  }
	  if (newNode instanceof Element && oldNode instanceof Element) {
	    if (!oldNode.isEqualNode(newNode)) {
	      copyAttributes(newNode, oldNode);
	    }
	  } else if (newNode instanceof Text || newNode instanceof Comment) {
	    if (oldNode.nodeValue !== newNode.nodeValue) {
	      oldNode.nodeValue = newNode.nodeValue;
	    }
	  }
	  if (newNode instanceof HTMLInputElement && oldNode instanceof HTMLInputElement) {
	    updateInput(newNode, oldNode);
	  } else if (newNode instanceof HTMLOptionElement && oldNode instanceof HTMLOptionElement) {
	    updateAttribute(newNode, oldNode, 'selected');
	  } else if (newNode instanceof HTMLTextAreaElement && oldNode instanceof HTMLTextAreaElement) {
	    updateTextarea(newNode, oldNode);
	  }
	}
	function getNodeKey(node, options) {
	  return options?.getNodeKey?.(node) ?? (node instanceof Element ? node.getAttribute('id') || undefined : undefined);
	}
	function updateAttribute(newNode, oldNode, name) {
	  const newValue = newNode[name];
	  const oldValue = oldNode[name];
	  if (newValue !== oldValue) {
	    oldNode[name] = newValue;
	    if (newValue != null) {
	      oldNode.setAttribute(name, '');
	    } else {
	      oldNode.removeAttribute(name);
	    }
	  }
	}
	function copyAttributes(newNode, oldNode) {
	  const oldAttrs = oldNode.attributes;
	  const newAttrs = newNode.attributes;
	  for (const attr of Array.from(newAttrs)) {
	    const {
	      name: attrName,
	      namespaceURI: attrNamespaceURI,
	      value: attrValue
	    } = attr;
	    const localName = attr.localName || attrName;
	    if (attrName === 'src' || attrName === 'href' || attrName === 'srcset' || attrName === 'poster') {
	      if (oldNode.getAttribute(attrName) === attrValue) continue;
	    }
	    if (attrNamespaceURI) {
	      const fromValue = oldNode.getAttributeNS(attrNamespaceURI, localName);
	      if (fromValue !== attrValue) {
	        oldNode.setAttributeNS(attrNamespaceURI, localName, attrValue);
	      }
	    } else {
	      if (!oldNode.hasAttribute(attrName)) {
	        oldNode.setAttribute(attrName, attrValue);
	      } else {
	        const fromValue = oldNode.getAttribute(attrName);
	        if (fromValue !== attrValue) {
	          if (attrValue === 'null' || attrValue === 'undefined') {
	            oldNode.removeAttribute(attrName);
	          } else {
	            oldNode.setAttribute(attrName, attrValue);
	          }
	        }
	      }
	    }
	  }
	  for (const attr of Array.from(oldAttrs)) {
	    if (attr.specified === false) continue;
	    const {
	      name: attrName,
	      namespaceURI: attrNamespaceURI
	    } = attr;
	    const localName = attr.localName || attrName;
	    if (attrNamespaceURI) {
	      if (!newNode.hasAttributeNS(attrNamespaceURI, localName)) {
	        oldNode.removeAttributeNS(attrNamespaceURI, localName);
	      }
	    } else if (!newNode.hasAttribute(attrName)) {
	      oldNode.removeAttribute(attrName);
	    }
	  }
	}
	function updateInput(newNode, oldNode) {
	  const newValue = newNode.value;
	  updateAttribute(newNode, oldNode, 'checked');
	  updateAttribute(newNode, oldNode, 'disabled');
	  if (newNode.indeterminate !== oldNode.indeterminate) {
	    oldNode.indeterminate = newNode.indeterminate;
	  }
	  if (oldNode.type === 'file') return;
	  if (newValue !== oldNode.value) {
	    oldNode.setAttribute('value', newValue);
	    oldNode.value = newValue;
	  }
	  if (newValue === 'null') {
	    oldNode.value = '';
	    oldNode.removeAttribute('value');
	  }
	  if (!newNode.hasAttributeNS(null, 'value')) {
	    oldNode.removeAttribute('value');
	  } else if (oldNode.type === 'range') {
	    oldNode.value = newValue;
	  }
	}
	function updateTextarea(newNode, oldNode) {
	  const newValue = newNode.value;
	  if (newValue !== oldNode.value) {
	    oldNode.value = newValue;
	  }
	  const firstChild = oldNode.firstChild;
	  if (firstChild?.nodeType === Node.TEXT_NODE) {
	    if (newValue === '' && firstChild.nodeValue === oldNode.placeholder) {
	      return;
	    }
	    firstChild.nodeValue = newValue;
	  }
	}
	function updateChildren(newNode, oldNode, options) {
	  if (oldNode instanceof Element && oldNode.hasAttribute('data-skip-subtree-update') && newNode instanceof Element && newNode.hasAttribute('data-skip-subtree-update')) {
	    return;
	  }
	  let oldChild;
	  let newChild;
	  let morphed;
	  let oldMatch;
	  let offset = 0;
	  for (let i = 0;; i++) {
	    oldChild = oldNode.childNodes[i];
	    newChild = newNode.childNodes[i - offset];
	    if (!oldChild && !newChild) {
	      break;
	    }
	    if (!newChild) {
	      if (oldChild) oldNode.removeChild(oldChild);
	      i--;
	      continue;
	    }
	    if (!oldChild) {
	      oldNode.appendChild(newChild);
	      offset++;
	      continue;
	    }
	    if (same(newChild, oldChild, options)) {
	      morphed = walk(newChild, oldChild, options);
	      if (morphed !== oldChild) {
	        oldNode.replaceChild(morphed, oldChild);
	        offset++;
	      }
	      continue;
	    }
	    if (options.reject?.(oldChild, newChild)) {
	      newNode.removeChild(newChild);
	      i--;
	      continue;
	    }
	    oldMatch = null;
	    for (let j = i; j < oldNode.childNodes.length; j++) {
	      const potentialOldNode = oldNode.childNodes[j];
	      if (potentialOldNode && same(potentialOldNode, newChild, options)) {
	        oldMatch = potentialOldNode;
	        break;
	      }
	    }
	    if (oldMatch) {
	      morphed = walk(newChild, oldMatch, options);
	      if (morphed !== oldMatch) offset++;
	      oldNode.insertBefore(morphed, oldChild);
	    } else if (!getNodeKey(newChild, options) && !getNodeKey(oldChild, options)) {
	      morphed = walk(newChild, oldChild, options);
	      if (morphed !== oldChild) {
	        oldNode.replaceChild(morphed, oldChild);
	        offset++;
	      }
	    } else {
	      oldNode.insertBefore(newChild, oldChild);
	      offset++;
	    }
	  }
	}
	function same(a, b, options) {
	  if (a.nodeType !== b.nodeType) return false;
	  if (a.nodeType === Node.ELEMENT_NODE) {
	    if (a instanceof Element && b instanceof Element && a.tagName !== b.tagName) return false;
	    const aKey = getNodeKey(a, options);
	    const bKey = getNodeKey(b, options);
	    if (aKey && bKey && aKey !== bKey) return false;
	  }
	  if (a.nodeType === Node.TEXT_NODE && b.nodeType === Node.TEXT_NODE) return a.nodeValue?.trim() === b.nodeValue?.trim();
	  if (a.nodeType === Node.COMMENT_NODE && b.nodeType === Node.COMMENT_NODE) return a.nodeValue === b.nodeValue;
	  return true;
	}

	var DOMMorph = /*#__PURE__*/Object.freeze({
		__proto__: null,
		morph: morph
	});

	function cleanHTML(html) {
	  return html.trim().replace(/>\s+</g, '><').replace(/<!--\s*shopify:rendered_by_section_api\s*-->/g, '');
	}
	class SectionRenderer {
	  cache = new Map();
	  abortControllersBySectionId = new Map();
	  pendingPromises = new Map();
	  constructor() {
	    if (typeof window !== 'undefined') {
	      window.addEventListener('load', this.cachePageSections);
	    }
	  }
	  async renderSection(sectionId, options) {
	    const {
	      cache = !(window.Shopify && window.Shopify.designMode)
	    } = options ?? {};
	    const {
	      url
	    } = options ?? {};
	    this.abortPendingMorph(sectionId);
	    const abortController = new AbortController();
	    this.abortControllersBySectionId.set(sectionId, abortController);
	    const sectionHTML = await this.getSectionHTML(sectionId, cache, url);
	    if (!abortController.signal.aborted) {
	      this.abortControllersBySectionId.delete(sectionId);
	      morphSection(sectionId, sectionHTML);
	    }
	    return sectionHTML;
	  }
	  abortPendingMorph(sectionId) {
	    const existingAbortController = this.abortControllersBySectionId.get(sectionId);
	    if (existingAbortController) {
	      existingAbortController.abort();
	    }
	  }
	  async getSectionHTML(sectionId, useCache = true, url = new URL(window.location.href)) {
	    const sectionUrl = buildSectionRenderingURL(sectionId, url);
	    let pendingPromise = this.pendingPromises.get(sectionUrl);
	    if (pendingPromise) return pendingPromise;
	    if (useCache) {
	      const cachedHTML = this.cache.get(sectionUrl);
	      if (cachedHTML) return cachedHTML;
	    }
	    pendingPromise = fetch(sectionUrl).then(response => {
	      return response.text();
	    });
	    this.pendingPromises.set(sectionUrl, pendingPromise);
	    const sectionHTML = await pendingPromise;
	    this.pendingPromises.delete(sectionUrl);
	    const cleanedHTML = cleanHTML(sectionHTML);
	    this.cache.set(sectionUrl, cleanedHTML);
	    return cleanedHTML;
	  }
	  cachePageSections = () => {
	    for (const section of Array.from(document.querySelectorAll('.shopify-section'))) {
	      const url = buildSectionRenderingURL(section.id);
	      if (this.cache.get(url)) return;
	      if (containsShadowRoot(section)) return;
	      this.cache.set(url, cleanHTML(section.outerHTML));
	    }
	  };
	}
	const SECTION_ID_PREFIX = 'shopify-section-';
	function buildSectionRenderingURL(sectionId, url = new URL(window.location.href)) {
	  url.searchParams.set('section_id', normalizeSectionId(sectionId));
	  url.searchParams.sort();
	  return url.toString();
	}
	function buildSectionSelector(sectionId) {
	  return `${SECTION_ID_PREFIX}${sectionId}`;
	}
	function normalizeSectionId(sectionId) {
	  return sectionId.replace(new RegExp(`^${SECTION_ID_PREFIX}`), '');
	}
	function containsShadowRoot(element) {
	  return !!element.shadowRoot || Array.from(element.children).some(containsShadowRoot);
	}
	async function morphSection(sectionId, html) {
	  const cleanedHTML = cleanHTML(html);
	  const fragment = new DOMParser().parseFromString(cleanedHTML, 'text/html');
	  const existingElement = document.getElementById(buildSectionSelector(sectionId));
	  const newElement = fragment.body.querySelector(`#${buildSectionSelector(sectionId)}`);
	  if (!existingElement) {
	    throw new Error(`Section ${sectionId} not found`);
	  }
	  if (!newElement) {
	    throw new Error(`Section ${sectionId} not found in the section rendering response`);
	  }
	  removeEmptyTextNodes(existingElement);
	  morph(existingElement, newElement);
	}
	function removeEmptyTextNodes(element) {
	  const childNodes = Array.from(element.childNodes);
	  for (const node of childNodes) {
	    if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.trim() === '') {
	      element.removeChild(node);
	    } else if (node.nodeType === Node.ELEMENT_NODE) {
	      removeEmptyTextNodes(node);
	    }
	  }
	}
	const sectionRenderer = new SectionRenderer();

	var SectionRenderer$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		buildSectionSelector: buildSectionSelector,
		morph: morph,
		morphSection: morphSection,
		normalizeSectionId: normalizeSectionId,
		sectionRenderer: sectionRenderer
	});

	class DateFormat {
	  defaultFormat = displayFormats[browserLocale] ?? browserFormat;
	  placeholder = this.defaultFormat;
	  constructor(locale) {
	    this.language = locale ?? storeLanguage;
	    if (browserLocale in languageFormats) this.placeholder = replaceMultiplePairs(this.defaultFormat, [['Y', languageFormats[browserLocale].year], ['M', languageFormats[browserLocale].month], ['D', languageFormats[browserLocale].day]]);
	  }
	  cleanForDigitOnly(str) {
	    return str.replace(/[^0-9]/g, '');
	  }
	  cleanAndNormalize(str) {
	    return str.replace(dateRegex, '').replace(/\s+/g, ' ').trim();
	  }
	  parse(str) {
	    const normalized = this.cleanAndNormalize(str);
	    const digitOnly = this.cleanForDigitOnly(normalized);
	    let result = undefined;
	    if (digitOnly.length != 8) return undefined;
	    parseFormats.find(format => {
	      if (normalized.length != format.length) return false;
	      const date = {
	        D: '',
	        M: '',
	        Y: ''
	      };
	      for (let i = 0; i < format.length; i++) {
	        if (['D', 'M', 'Y'].includes(format[i]) && normalized[i] >= '0' && normalized[i] <= '9') {
	          date[format[i]] += normalized[i];
	          continue;
	        }
	        if (format[i] != normalized[i]) return false;
	      }
	      const timestamp = Date.parse(`${date.Y}-${date.M}-${date.D}`);
	      if (isNaN(timestamp)) return false;
	      result = timestamp;
	      return true;
	    });
	    return result;
	  }
	  convertValueToTimestamp(value) {
	    if (typeof value == 'number') return value;else if (typeof value == 'string') return this.parse(value);else return undefined;
	  }
	  format(value, format) {
	    let timestamp = this.convertValueToTimestamp(value);
	    if (!timestamp) return undefined;
	    const dateObj = new Date(timestamp);
	    if (format) {
	      const date = {
	        D: String(dateObj.getDate()).padStart(2, '0').split(''),
	        M: String(dateObj.getMonth() + 1).padStart(2, '0').split(''),
	        Y: String(dateObj.getFullYear()).split('')
	      };
	      let formatted = format.split('').map(char => {
	        if (['D', 'M', 'Y'].includes(char)) return date[char].shift();
	        return char;
	      }).join('');
	      return formatted;
	    } else {
	      return dateObj.toLocaleDateString(this.language);
	    }
	  }
	}

	class KeyboardNavigationHook {
	  isUsingKeyboard = false;
	  constructor(options) {
	    this.options = {
	      autoWatch: true,
	      ...options
	    };
	    if (this.options.autoWatch) this.watch();
	  }
	  watch() {
	    document.addEventListener('keydown', this.handleKeydown);
	    document.addEventListener('mousedown', this.handleMousedown);
	  }
	  stop() {
	    document.removeEventListener('keydown', this.handleKeydown);
	    document.removeEventListener('mousedown', this.handleMousedown);
	  }
	  handleKeydown = e => {
	    if (this.isUsingKeyboard === true) return;
	    if (this.isNavigationKey(e.key)) {
	      this.isUsingKeyboard = true;
	      document.body.classList.add('keyboard-navigation');
	      if (this.options.onKeyboardEvent) this.options.onKeyboardEvent();
	    }
	  };
	  handleMousedown = () => {
	    if (this.isUsingKeyboard === false) return;
	    this.isUsingKeyboard = false;
	    document.body.classList.remove('keyboard-navigation');
	    if (this.options.onMouseEvent) this.options.onMouseEvent();
	  };
	  isNavigationKey(key) {
	    const navigationKeys = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
	    return navigationKeys.includes(key);
	  }
	  isKeyboardUser() {
	    return this.isUsingKeyboard;
	  }
	}

	class BaseComponent extends HTMLElement {
	  connectedCallback() {
	    this.controller = new AbortController();
	    this.onMount();
	  }
	  disconnectedCallback() {
	    this.controller?.abort();
	    this.controller = undefined;
	    this.onUnmount();
	  }
	  updatedCallback() {
	    this.refresh();
	  }
	  refresh() {
	    this.controller?.abort();
	    this.controller = new AbortController();
	    this.onMount();
	  }
	  onMount() {}
	  onUnmount() {}
	}
	class SSRComponent extends BaseComponent {
	  syncHTML(html) {
	    const isHtmlEmpty = !html || !html.trim();
	    const container = this.contentContainer || this;
	    if (!isHtmlEmpty) {
	      container.innerHTML = html;
	      container.classList.add('visible');
	      container.classList.remove('hidden');
	      if (this.emptyState) {
	        this.emptyState.classList.add('hidden');
	        this.emptyState.classList.remove('visible');
	      }
	    } else {
	      container.innerHTML = '';
	      container.classList.remove('visible');
	      container.classList.add('hidden');
	      if (this.emptyState) {
	        this.emptyState.classList.remove('hidden');
	        this.emptyState.classList.add('visible');
	      }
	    }
	  }
	}

	var BaseComponent$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BaseComponent: BaseComponent,
		SSRComponent: SSRComponent
	});

	window.PoleneLibs = {
	  Utils,
	  Refs,
	  Breakpoints,
	  Events,
	  Observer,
	  SvgTemplates,
	  ScrollLock,
	  FlipAnimation,
	  ElementTemplates,
	  Hydration,
	  ConstantsDate,
	  CartEvents,
	  ModalEvents,
	  BlogArticleEvents,
	  SectionRenderer: SectionRenderer$1,
	  DateFormat,
	  KeyboardNavigationHook,
	  DOMMorph,
	  BaseComponent: BaseComponent$1
	};
	window.dispatchEvent(new CustomEvent(events.POLENE_LIBS_READY));

})();
